import CryptoJS from 'crypto-js';
import {IKey} from './alias';

export const Write = ({name, key}: IKey, data: any) => {
  try {
    const encriptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      key,
    ).toString();
    localStorage.setItem(name, encriptedData);
    return true;
  } catch (error) {
    return null;
  }
};

export const Read = ({name, key}: IKey) => {
  try {
    const lsData = localStorage.getItem(name);
    if (lsData) {
      var bytes = CryptoJS.AES.decrypt(lsData, key);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const Remove = ({name, key}: IKey) => {
  try {
    localStorage.removeItem(name);
    return true;
  } catch (error) {
    return null;
  }
};

export * from './alias';
